<template>
    <div class="users_filter">
        <b-modal id="users_filter"
                 v-bind:no-close-on-backdrop=true
                 :hide-header=true
                 v-model="show"
                 size="xl"
                 bodyClass="p-0"
                 title="Заміна останнього погоджувача"
        >
            
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2>
                    Змінити <span class="fw-300">останнього погоджувача</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            
            <div class="panel-container show">
                <div class="panel-content p-2">
                    <b-row>
                        
                        <b-col sm="6" class="adjusted_list ">
                            <div class="isp_list" >
                                <user_block :show_vacation=true  v-for="(item) in this.adjust" :key="item.id" v-bind:user="item"></user_block>
                            </div>
                        </b-col>
                        
                        <b-col sm="6">
                            <div class="search_form">
                                <div class="search_filed">
                                    
                                    <b-input-group>
                                        <b-input-group-text slot="prepend" >по ПІБ, посада</b-input-group-text>
                                        <b-form-input v-model="search"></b-form-input>
                                    </b-input-group>
                                    
                                    <div class="users_list pt-3 ml-0 pl-0">
                                        <ul class="user_list_to_insert ml-0 pl-0">
                                            <li v-for="(item) in searched"   >
                                                <div class="user_profile position-relative border mb-2" >
                                                    <div class="d-flex flex-row pt-2 pl-2 pb-2" >
                                                 <span class="status " >
                                                        <span class="profile-image rounded-circle d-inline-block "
                                                              v-bind:style="{
                                                                  'background-image': 'url(' + item.medium_img + ')',
                                                                  'background-size': 'cover'
                                                                   }"
                                                        ></span>
                                                 </span>
                                                        <!-- profile photo end -->
                                                        <div class="ml-3">
                                                            <div class="user_attrib">
                                                                <div class="name d-block fw-700 text-dark" v-text=item.name></div>
                                                                <div class="company small text-dark" v-text=user_company(item)></div>
                                                                <div class="dolznost small text-dark" v-text=item.dolznost></div>
                                                                <div class="vacation">
                                                                    <vacation :id=parseInt(item.id)></vacation>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div class="add_adjust" >
                                                            <div class="add_in_start cursor-pointer bg-warning-500 shadow text-white"  @click.prevent="set_active(item)">
                                                                Вибрати
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
            
            <template slot="modal-footer" slot-scope="{ ok, cancel }">
                <b-spinner variant="success" v-if="show_action"></b-spinner>
                
                <b-button size="xl" variant="outline-primary" @click.prevent="close_filter()"  class="btn btn-lg  waves-effect waves-themed mr-3">
                    <i class="fal fa-check mr-1"></i>
                    Зберегти
                </b-button>
                
            </template>
        </b-modal>
    </div>
</template>

<script>

import user_block from "../../../../../shared/user/user_block/user_block.vue";
import draggable from 'vuedraggable'
import vacation from "../../../../../shared/user/user_block/vacation.vue";

export default {
    name: "adjust_replace",
    components : {
        user_block,
        draggable,
        vacation
    },
    
    data() {
        return  {
            show : false,
            show_action : false,
            uniq_call : '',
            
            
            
            
            doc_id : 0,
            search : '',
            search_after : '',
            adjust : [],
            
            added  : [],
            added_after  : [],
            
            recipient_added : [],
            
            searched : [],
            
            
            dir:{},
            form : {
                search : '',
                cur_type : 'search'
            },
            
        }
    },
    
    created() {
        EventBus.$on('load_users_replace', e => {
            if(e !== undefined) {
                this.doc_id = e.doc_id;
                this.load_adjust();
            }
            this.show = true;
        });
    },
    
    computed : {
    
    },
    
    methods : {
        
        close() {
            this.show = false;
            this.show_action = false
        },
        
        dragOptions(type) {
            return {
                animation: 200,
                group: "description" + type,
                disabled: false,
                ghostClass: "ghost"
            };
        },
        send_form (search) {
            this.form.search = search;
            return this.form;
        },
        
        close_filter () {
            this.show_action = true;
            this.try_save(res => {
                setTimeout(() => {
                    this.show_action = false
                    this.show = false;
                }, 500);
            })
        },
        
        set_active (item) {
            this.adjust = [item];
        },
        
        user_company (item) {
            if(this.obj_to_null(item) != null) {
                return item.company + ", " + item.department
            }
        },
        
        async load_users_search(srch,type) {
            if (srch.length > 2) {
                await api.post('/users', this.send_form(srch)).then(({data}) => {
                    if (data.status === "operation_success") {
                        if(type == 'standart') {
                            this.searched = data.data;
                        }
                    }
                }).catch(err => {
                    this.is_load = false;
                });
            }
            
        },
        
        async load_adjust() {
            
            await api.get('/memorandums/' + this.doc_id + "/adjusts").then(({data}) => {
                if (data.status === "operation_success") {
                    let last_adjust = data.data.editable.pop();
                    if(this.obj_to_null(last_adjust)) {
                        this.adjust = [last_adjust];
                    }
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        async try_save(callback) {
            await api.patch('/memorandums/' + this.doc_id + '/adjust/replace/' + this.adjust[0].id).then(({data}) => {
                console.log(data);
                if (data.status === "operation_success") {
                    EventBus.$emit('refresh_tabs', {
                        tabs: [
                            'tab_monitoring',
                            'tab_resolution',
                            'tab_files',
                            'tab_work'
                        ]
                    });
                    callback('OK');
                } else {
                    EventBus.$emit('show_toast', {err: data.errors, type: "danger", title: data.message});
                    callback('err');
                }
                
            }).catch(err => {
                callback('err');
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        }
        
    },
    
    watch: {
        
        'search': function () {
            console.log('addon_change', this.search);
            if(this.search.length > 2) {
                this.load_users_search(this.search,'standart');
            }
            else {
                this.searched =[];
            }
        },
        
        
        
        
    }
}
</script>

<style scoped>
.add_in_start {
    position: absolute;
    top: 5px;
    right: 13px;
}

.add_in_end{
    position: absolute;
    bottom: 5px;
    right: 13px;
}

.add_in_end,
.add_in_start {
    padding: 2px;
    width: 100px;
    text-align: center;
}




.user_list_to_insert li {
    width: 100%;
}
#users_filter .search_filed {
    padding: 0;
    margin-left: 0;
}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.list-group {
    min-height: 20px;
}
.list-group-item {
    cursor: move;
}
.list-group-item i {
    cursor: pointer;
}

.adj_move {
    cursor: move;
}

.u_list {
    box-shadow: 0 1px 2px #999;
    margin-bottom: 10px;
    border-top: 8px solid #eee;
    position: relative;
}

.u_list .user_profile {
    border-top:1px solid #eee;
    padding-top: 2px;
    padding-bottom: 2px;
}

.add_in_end_rec {
    width:170px;
}

ul.user_list_to_insert {
    margin-left: 0;
    width: 100%;
    float: left;
    max-height: 311px;
    overflow-y: auto;
}

</style>
